import cn from 'classnames'
import { memo, type ReactElement } from 'react'

function SuccessCheck ({ additionalClasses }: { additionalClasses?: string }): ReactElement {
  return (
    <div>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 130.2 130.2" className={cn('block', additionalClasses)}>
        <circle
          cx="65.1"
          cy="65.1"
          r="62.1"
          fill="none"
          strokeMiterlimit="10"
          strokeWidth="6"
          className="animate-checkCircleDash stroke-current text-green-700"
          style={{ strokeDasharray: 1000, strokeDashoffset: 0 }}
        />
        <path
          fill="none"
          stroke="#73AF55"
          strokeLinecap="round"
          strokeMiterlimit="10"
          strokeWidth="6"
          d="M100.2 40.2L51.5 88.8 29.8 67.5"
          className="animate-checkCircleDashCheck stroke-current text-green-700"
          style={{ strokeDasharray: 1000, strokeDashoffset: -100 }}
        />
      </svg>
    </div>
  )
}

export default memo(SuccessCheck)
